import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const ReferralRedirect = () => {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("referralCode") || "";

  useEffect(() => {
    if (!referralCode) return;

    const userAgent = navigator.userAgent.toLowerCase();
    let redirectUrl = "https://ybedatingapp.web.app/";

    if (userAgent.includes("android")) {
      redirectUrl = `https://play.google.com/store/apps/details?id=com.ybe.social&referralCode=${referralCode}`;
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      redirectUrl = `https://apps.apple.com/app/ybe-app/id310633997?referralCode=${referralCode}`;
    } 

    window.location.href = redirectUrl;
  }, [referralCode]);

  return <p>Redirecting...</p>;
};

export default ReferralRedirect;
